/**
 * useAppleDevice — Vue 3 composable for detecting Apple devices.
 * Identifies iPhone, iPad, Mac, and Vision Pro visitors to
 * promote the native App Store app where appropriate.
 */

import { ref, onMounted } from 'vue'

export function useAppleDevice() {
  const isAppleDevice = ref(false)
  const deviceName = ref('')
  const appStoreUrl = 'https://apps.apple.com/app/sankeymaster-sankey-diagram/id6474908221'

  function detect() {
    const ua = navigator.userAgent || ''
    const platform = navigator.platform || ''

    if (/xrOS|visionOS|VisionPro/i.test(ua) || /VisionPro/i.test(platform)) {
      isAppleDevice.value = true
      deviceName.value = 'Apple Vision Pro'
      return
    }
    if (/iPhone/i.test(ua) || /iPhone/i.test(platform)) {
      isAppleDevice.value = true
      deviceName.value = 'iPhone'
      return
    }
    if (/iPad/i.test(ua) || /iPad/i.test(platform)) {
      isAppleDevice.value = true
      deviceName.value = 'iPad'
      return
    }
    if (/MacIntel/i.test(platform) && navigator.maxTouchPoints > 1 && !/iPhone|iPad|iPod/i.test(ua)) {
      isAppleDevice.value = true
      deviceName.value = 'iPad'
      return
    }
    if (/Mac/i.test(ua) || /Mac/i.test(platform)) {
      isAppleDevice.value = true
      deviceName.value = 'Mac'
      return
    }
  }

  onMounted(() => { detect() })

  return { isAppleDevice, deviceName, appStoreUrl }
}

export default useAppleDevice
